// extracted by css-extract-rspack-plugin
export {};
    if(module.hot) {
      // 1745321042133
      var cssReload = require("../node_modules/@rspack/core/dist/builtin-plugin/css-extract/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  